import * as React from 'react'
import { CalendarToday } from '@workwave-tidal/core/icons/CalendarToday'
import { CalendarIcon } from '@sales-center/components'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

import { format } from 'date-fns'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import {
  CAN_DATE_EMPTY_PLACEHOLDER,
  CAN_DATE_FORMAT,
  US_DATE_EMPTY_PLACEHOLDER,
} from './typings'

export interface CalendarProps {
  onClick: any
  date: Date | null | string
  disabled?: boolean
  formatString?: string
  color?: string
  dataTestId?: string
  textOnly?: boolean
}

export const CalendarButton = (props: CalendarProps) => {
  const tidalThemeActive = useTidalThemeActive()

  const placeholder = React.useMemo(() => {
    if (props.formatString == CAN_DATE_FORMAT) {
      return CAN_DATE_EMPTY_PLACEHOLDER
    }
    return US_DATE_EMPTY_PLACEHOLDER
  }, [props.formatString])

  return (
    <Button
      variant="text"
      onClick={props.onClick}
      disabled={props.disabled}
      data-test-id={props.dataTestId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: tidalThemeActive ? 0.8 : 0,
      }}
    >
      <Typography
        color="#1565c0"
        sx={{
          letterSpacing: '0.46px',
          lineHeight: '10px',
          fontSize: tidalThemeActive ? '14px' : '13px',
          fontWeight: 500,
        }}
      >
        {props.date
          ? props?.formatString
            ? format(new Date(props.date), props?.formatString)
            : new Date(props.date).toDateString()
          : placeholder}
      </Typography>
      {!props.textOnly && (
        <>
          {tidalThemeActive ? (
            <CalendarToday fontSize="small" />
          ) : (
            <CalendarIcon color={props.color || '#1565C0'} />
          )}
        </>
      )}
    </Button>
  )
}
